<template>
  <div class="evaluationListDetail common_content">
    <div class="news_detail">
      <el-card class="box-card">
        <el-row :gutter="24">
          <el-col :xs="24" :sm="24" :md="24" v-if="evaluationContents">
            <div class="news_detail_top">
              <h3>{{evaluationContents.name}}</h3>
              <p class="date">
                <span style="padding:0px 10px;">性别：{{evaluationContents.sex}}</span>
                <span style="padding:0px 10px;">等级：{{evaluationContents.gradeName}}</span>
              </p>
              <span @click="goBack">返回</span>
            </div>
            <div style="text-align: center;">
              <img v-if="athletes_photo" style="width: 40%; height: 30%;"
                :src="athletes_photo" class="badge" />
            </div>
              <div class="base_title">
                <p>
                  {{evaluationContents.name}}，{{evaluationContents.gradeName}}, {{evaluationContents.address}}
                </p>
                <p>考评员培训记录：</p>
                <li v-for="(item,index) in existRecord" :key="index" >
                  <!-- <span>{{item.existDate}},{{item.trainClassName}}培训成功，获得{{item.gradeName}}</span> -->
                  <span style="color:red">{{item.existDate}}</span>，<span style="color:red">{{item.trainClassName}}</span>培训成功，获得
                  <span style="color:red">{{item.gradeName}}</span>
                </li>
                <br>
                 <p>考评员工作记录：</p>
                <li v-for="(item,index) in workRecord" :key="index">
                  <!-- <span>{{item.workDate}},{{item.testClassName}}等级测试，担任{{item.gradeName}}</span> -->
                  <span style="color:red">{{item.workDate}}</span>，<span style="color:red">{{item.testClassName}}</span>等级测试，担任
                  <span style="color:red">{{item.gradeName}}</span>
                </li>
              </div>
            <!-- <div v-if="introduce" class="news_detail_bottom" v-html="introduce"></div> -->
            <!-- <no-data v-else /> -->
          </el-col>
        </el-row>
      </el-card>
    </div>

    <div class="coachDetail">

    </div>
  </div>
  
</template>
<script>
import { getUserCoachData2 } from "@/api/admin/appraiser.js";
import { GetDicData } from "@/api/admin/common.js";
// import noData from "@/views/admin/components/noData.vue";
let that;
export default {
  // components: {
  //   noData
  // },
  data() {
    return {
      evaluationContents: {},
      appraiser_grade: [],
      imgPath: window.apiObj.apiUrl,
      introduce: "",
      athletes_photo: "",
      existRecord: [],
      workRecord: [],
    };
  },
  created() {
    
    this.path();
    this.getDetail();
    GetDicData({ classCode: "appraiser_grade" }).then(data => {
      if (data.data.result) {
        this.appraiser_grade = data.data.result;
      }
    });
  },
  beforeCreate: function() {
    that = this;
  },
  methods: {
    path() {
      var pathList = [
        { title: "您当前的位置" },
        { title: "首页", path: "/index" },
        { title: "考评员", path: "/evaluationStaffTraining" },
        { path: "/evaluationList", title: "考评员列表" },
        {
          title: "考评员详情"
        }
      ];
      setTimeout(() => {
        this.$store.commit("SET_ROUTELIST", pathList);
      });
    },
    getDetail() {
      this.newsId = this.$route.query.id;
      // getUserCoachData(Object.assign({ id: Number(this.newsId) })).then(
      //   data => {
      //     var list = data.data.result;
      //     if (list) {
      //       this.evaluationContents = list.items[0];
      //       if (list.items[0].introduce) {
      //         this.introduce = list.items[0].introduce.replace(
      //           new RegExp("/wwwroot", "gm"),
      //           this.imgPath
      //         );
      //       }
      //       if (list.items[0].athletes_photo) {
      //         this.athletes_photo = list.items[0].athletes_photo;
      //       }
      //     }
      //   }
      // );
        getUserCoachData2(Object.assign({ id: Number(this.newsId) })).then(
        data => {
          var list = data.data.result;
          if (list) {
            this.evaluationContents = list.coachInfo;
            
            // if (list.items[0].introduce) {
            //   this.introduce = list.items[0].introduce.replace(
            //     new RegExp("/wwwroot", "gm"),
            //     this.imgPath
            //   );
            // }
            if (this.evaluationContents.photo) {
              //this.athletes_photo = "http://218.58.55.130:8765"+this.evaluationContents.photo ;
              this.athletes_photo = this.imgPath+this.evaluationContents.photo ;
            }
             if (this.evaluationContents.existRecord) {
              this.existRecord = this.evaluationContents.existRecord ;
            }
             if (this.evaluationContents.workRecord) {
              this.workRecord = this.evaluationContents.workRecord ;
            }
          }
        }
      );
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  filters: {
    app_grade: data => {
      for (var i in that.appraiser_grade) {
        if (that.appraiser_grade[i].value == data) {
          return that.appraiser_grade[i].label;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.evaluationListDetail {
  .news_detail {
    .base_title{
      padding-left: 10%;
    }
    .news_detail_top {
      padding-top: 15px;
      width: 85%;
      margin: auto;
      position: relative;
      h3 {
        text-align: center;
        font-size: 20px;
        font-weight: normal;
      }
      .date {
        text-align: center;
        font-size: 14px;
        color: #8a8a8a;
        margin: 20px 0 25px 0;
        border-bottom: 1px solid #cdcccc;
        padding-bottom: 15px;
      }
      & > span {
        cursor: pointer;
        position: absolute;
        color: #f56c6c;
        top: 26%;
        right: 0;
      }
    }
    .news_detail_bottom {
      width: 85%;
      margin: auto;
    }
  }
}
</style>